import { render, staticRenderFns } from "./ShowArticle.vue?vue&type=template&id=b78cc57a"
import script from "./ShowArticle.vue?vue&type=script&lang=js"
export * from "./ShowArticle.vue?vue&type=script&lang=js"
import style0 from "./ShowArticle.vue?vue&type=style&index=0&id=b78cc57a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports